import React from 'react'
import { useIntl } from 'react-intl'

import ModalFooterActionContainer from '../TripModal/TripItems/Create/ModalFooterActionContainer'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'

interface Props {
  updateTripDates: () => void
  currentTripDates: string
  extendedTripDates: string
  isLoading: boolean
}

function ConfirmUpdateTripDatesModal(props: Props) {
  const { updateTripDates, isLoading, currentTripDates, extendedTripDates } =
    props

  const intl = useIntl()
  const { closeModal, goBack } = useModalCallbacks()
  const isMobile = useScreenSizeOnly('mobile')

  return (
    <>
      <ModalHeader
        title={intl.formatMessage({
          id: 'iwlOKa5kJS',
          defaultMessage: 'Extend trip duration',
          description: 'Modal title for confirming trip date extension',
        })}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={12}>
            <BodyTextBlock variant="large">
              {intl.formatMessage({
                id: 'yuP+ph2MQV',
                defaultMessage: 'Please check the new dates for your trip',
                description: 'Instruction asking user to review the proposed new trip dates',
              })}
            </BodyTextBlock>
            <div>
              <BodyTextBlock variant="large">
                <b>{intl.formatMessage({
                  id: '24q20O8nCJ',
                  defaultMessage: 'Current trip dates:',
                  description: 'Label for the current trip date range',
                })}
                </b>{' '}{currentTripDates}
              </BodyTextBlock>
              <BodyTextBlock variant="large">
                <b>{intl.formatMessage({
                  id: '9/bIiW7Bqh',
                  defaultMessage: 'New trip dates:',
                  description: 'Label for the proposed new trip date range',
                })}
                </b>{' '}{extendedTripDates}
              </BodyTextBlock>
            </div>
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <ModalFooterActionContainer>
          <TextButton
            kind="secondary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={closeModal}
          >
            Cancel
          </TextButton>
          <TextButton
            kind="primary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={updateTripDates}
            disabled={isLoading}
          >
            {intl.formatMessage({
              id: '0WWj9AhCf6',
              defaultMessage: 'Confirm new trip dates',
              description: 'Button to confirm and save the extended trip dates',
            })}
          </TextButton>
        </ModalFooterActionContainer>
      </ModalFooter>
    </>
  )
}

export default ConfirmUpdateTripDatesModal
